import { useState } from "react"
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Button, useMediaQuery } from "@mui/material";
import { API } from "../../lib/api";
import { useAppSettings } from "../../contexts/AppSettingsContext";

const AuthForm = ({ setMessage }) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [inputFocused, setInputFocused] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation()
    const [formData,setFormData] = useState({ email: "", password: "" })
    const { applicationSettings } = useAppSettings();

    const inputStyle = {
        fontSize: '16px',
        ...(isMobile && inputFocused && {
          transform: 'scale(1)', // Prevent zooming when focused
          transition: 'transform 0.2s ease-in-out',
        }),
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await API.Authentication.Login(formData)

        if (response.status === 200) {
            const userData = response.data;
            
            if (userData && userData.id) {
                login(userData);

                const from = location.state?.from?.pathname
                const defaultRoute = "/dashboard"
                const redirectTo = from || defaultRoute

                setTimeout(() => navigate(redirectTo, { replace: true }), 0)

            } else {
                setMessage({open: true, message: "Incorrect Username or Password...", type: "error"})
            }
        
        } else {
            setMessage({open: true, message: "Incorrect Username or Password...", type: "error"})
        }

        e.target.reset();
    }

    return (
        <div className="auth-main">
            <div className="auth-wrapper v1">
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="card my-5">

                        <div className="card-body">
                            <div className="text-center" style={{display: "flex", justifyContent: "center"}}>
                                <a href="/"><img src="images/LOGO.png" alt="img" style={{width: "60px", marginBottom: "1em"}}/></a>
                            </div>
                            <h4 className="text-center f-w-500 mb-3" style={{textAlign: "center", marginBottom: "1em"}}>Login with your email</h4>
                            <div className="form-group mb-3">
                                <input type="email" className="form-control" id="floatingInput" placeholder="Email Address"
                                    style={inputStyle}
                                    onFocus={() => setInputFocused(true)}
                                    onBlur={() => setInputFocused(false)}
                                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                                />
                            </div>
                            <div className="form-group mb-3">
                                <input type="password" className="form-control" id="floatingInput1" placeholder="Password" 
                                    style={inputStyle}
                                    onFocus={() => setInputFocused(true)}
                                    onBlur={() => setInputFocused(false)}
                                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                                />
                            </div>
                            <div className="d-grid mt-4">
                                <Button variant="contained" type="submit" sx={{width: "100%"}}>Login</Button>
                                <Button component={Link} to="/forgot-password">Forgot password?</Button>
                            </div>
                            <div className="d-grid" style={{marginTop: "1em"}}>
                                <p style={{color: "#6c757d", fontSize: "14px", textAlign: "center", margin: 0}}>Production - {applicationSettings.applicationVersion}</p>
                            </div>
                            {/* <div className="d-grid" style={{marginTop: "0.25em"}}>
                                <p style={{color: "red", fontWeight: "bold", fontSize: "14px", textAlign: "center", margin: 0}}>Scheduled Downtime:</p>
                            </div>
                            <div className="d-grid" style={{marginTop: "0em"}}>
                                <p style={{color: "red", fontWeight: "bold", fontSize: "14px", textAlign: "center", margin: 0}}>5/3/25 8:00AM - 5/3/25 11:00AM</p>
                            </div> */}
                        </div>

                    </div>
                </form>
            </div>
        </div>
    )
}

export default AuthForm
